import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import {
  DataGrid, Editing, Scrolling, Selection, SearchPanel, Grouping, GroupPanel,
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { CurrentSwitch } from '~/components/current-switch/current-switch';
import { calcGridHeight } from '~/helpers/ui';
import { AppContext } from '~/app-context';
import { CreateAuthorizedDataSource } from '~/helpers/data';
import { appConst } from '~/app-const';

import './admin-component.scss';

const URL = `${window.env.apiEndpoint}/api/v1`;

export class AdminComponent extends Component {
  constructor(props) {
    super(props);

    this.toolbarItemRender = this.toolbarItemRender.bind(this);
    this.windowResized = this.windowResized.bind(this);
    const { componentName } = this.props;
    this.dataSource = CreateAuthorizedDataSource(
      {
        loadUrl: `${URL}/${componentName}/Get`,
        updateUrl: `${URL}/${componentName}/Put`,
        deleteUrl: `${URL}/${componentName}/Delete`,
        insertUrl: `${URL}/${componentName}/Post`,
      }, null, 'Id',
    );
    this.gridRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.windowResized);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResized);
    if (this.dataSource && this.dataSource.isLoaded()) {
      this.dataSource.dispose();
    }
  }

  static onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        template: 'switchCurrent',
      },
    );
  }

  toolbarItemRender() {
    return (
      <CurrentSwitch grid={this.gridRef} />
    );
  }

  windowResized() {
    this.gridRef.current.instance().option('height', calcGridHeight('membersGrid'));
  }

  render() {
    const { title, extraColumns } = this.props;

    return (
      <>
        <div className="title">
          <span>{title}</span>
        </div>
        <DataGrid
          id="grid"
          ref={this.gridRef}
          dataSource={this.dataSource}
          {...appConst.defaultAdminGridOptions}
          onToolbarPreparing={AdminComponent.onToolbarPreparing}
          onInitialized={(e) => {
            e.component.option('height', calcGridHeight(e.component.element().id));
          }}
          columns={[...appConst.defaultAdminColumns, ...(extraColumns || [])]}
        >
          <Selection mode="multiple" />
          <SearchPanel
            visible
            width={240}
            placeholder="Search..."
          />
          <Scrolling
            mode="virtual"
            rowRenderingMode="virtual"
          />
          <Editing
            mode="row"
            allowAdding
            allowDeleting
            allowUpdating
          />
          <Grouping contextMenuEnabled />
          <GroupPanel visible />
          
          <Template name="switchCurrent" render={this.toolbarItemRender} />
        </DataGrid>
      </>
    );
  }
}

AdminComponent.propTypes = {
  componentName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

AdminComponent.contextType = AppContext;
